import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./kartArchive.css";
import Layout from "../../components/layout";

const Menu = () => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [menuData, setMenuData] = useState({});

  const fetchCategories = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/categories`
      );
      const data = await response.json();
      const sortedCategories = data.sort((a, b) => a.localeCompare(b));
      setCategories(sortedCategories);
    } catch (error) {
      toast.error("Fehler beim Abrufen der Kategorien.");
    }
  };

  const fetchData = async (category) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/getraenke/${category}`
      );
      const data = await response.json();
      const sortedProducts = data.sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      setMenuData((prevData) => ({ ...prevData, [category]: sortedProducts }));
    } catch (error) {
      toast.error("Fehler beim Abrufen der Produkte.");
    }
  };

  const archiveProduct = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/getraenke/${id}/archive`,
        {
          method: "PUT",
        }
      );
      if (!response.ok) throw new Error("Fehler beim Archivieren des Produkts.");

      toast.success("Produkt erfolgreich archiviert.");
      fetchData(selectedCategory);
    } catch (error) {
      toast.error("Fehler beim Archivieren des Produkts.");
    }
  };

  const unarchiveProduct = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/getraenke/${id}/unarchive`,
        {
          method: "PUT",
        }
      );
      if (!response.ok) throw new Error("Fehler beim Reaktivieren des Produkts.");

      toast.success("Produkt erfolgreich reaktiviert.");
      fetchData(selectedCategory);
    } catch (error) {
      toast.error("Fehler beim Reaktivieren des Produkts.");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleCategoryChange = (event) => {
    const category = event.target.value;
    setSelectedCategory(category);
    if (category) {
      fetchData(category);
    }
  };

  const products = menuData[selectedCategory] || [];

  return (
    <Layout>
      <div className="Bottom Top">
        <div className="Bottom12">
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={true}
            newestOnTop={true}
            closeOnClick
            pauseOnHover
            limit={1}
            style={{ width: "250px", fontSize: "14px" }}
          />
          <div className="menu">
            <h1 className="menu-heading">Getränke Menü</h1>

            <div className="category-dropdown">
              <label htmlFor="category-select">Kategorie auswählen:</label>
              <select
                id="category-select"
                value={selectedCategory}
                onChange={handleCategoryChange}
              >
                <option value="">-- Kategorie auswählen --</option>
                {categories.map((category, index) => (
                  <option key={index} value={category}>
                    {category.charAt(0).toUpperCase() + category.slice(1)}
                  </option>
                ))}
              </select>
            </div>

            {selectedCategory && (
              <div className="menu-products">
                <h2 className="products-heading">
                  {selectedCategory.charAt(0).toUpperCase() +
                    selectedCategory.slice(1)}
                </h2>
                {products.length > 0 ? (
                  <ul className="product-list">
                    {products.map((product) => (
                      <li key={product.id} className="product-item">
                        <div className="product-details">
                          <h3 className="product-title">{product.title}</h3>
                          <p className="product-attribute">
                            Menge: {product.menge || "Keine Angabe"}
                          </p>
                          <p className="product-attribute">
                            Preis: {product.preis} €
                          </p>
                          {product.inhaltstoffe && (
                            <p className="product-attribute">
                              Inhaltsstoffe: {product.inhaltstoffe}
                            </p>
                          )}
                        </div>
                        <div className="product-actions">
                          {product.archiviert ? (
                            <button
                              className="product-button unarchive"
                              onClick={() => unarchiveProduct(product.id)}
                            >
                              Reaktivieren
                            </button>
                          ) : (
                            <button
                              className="product-button archive"
                              onClick={() => archiveProduct(product.id)}
                            >
                              Archivieren
                            </button>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="no-products">
                    Keine Produkte in dieser Kategorie verfügbar.
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Menu;
